import PricesAndPlans from './PricesAndPlans';

export default PricesAndPlans;
